import React from 'react';
export function MoveArrowsIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M17.747 8.658l1.506-1.317L23.329 12l-4.076 4.659-1.506-1.317 2.244-2.564-7.018.195-.195 7.017 2.563-2.243 1.318 1.506L12 23.329l-4.659-4.076 1.317-1.506 2.564 2.243-.195-7.017-7.017-.195 2.243 2.563-1.506 1.318L.671 12l4.076-4.659 1.506 1.317-2.244 2.564 7.018-.195.195-7.018-2.564 2.243-1.317-1.505L12 .671l4.659 4.076-1.317 1.505-2.564-2.243.195 7.018 7.017.195-2.243-2.564z"
  }));
}